"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Layout = exports.Sizes = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var styled_components_1 = tslib_1.__importDefault(require("styled-components")); // Any additional sizes to be added here


var Sizes;

(function (Sizes) {
  Sizes[Sizes["medium"] = 1] = "medium";
})(Sizes = exports.Sizes || (exports.Sizes = {}));

var Layout;

(function (Layout) {
  Layout["page"] = "page";
  Layout["item"] = "item";
})(Layout = exports.Layout || (exports.Layout = {}));

exports.Root = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  background-color: ", ";\n  border-radius: ", "\n  height: ", ";\n"], ["\n  background-color: ", ";\n  border-radius: ", "\n  height: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["200"]', theme);
}, function (_a) {
  var layout = _a.layout;
  return layout === Layout.item ? "".concat((0, ui_symbols_1.calcSpace)(Sizes.medium / 2), ";") : "0;";
}, (0, ui_symbols_1.calcSpace)(Sizes.medium));
var templateObject_1;